/**
 * The access token lives in memory ONLY — never localStorage/sessionStorage (an
 * XSS-exfiltration guard). It is a plain module ref (not React state) so the API
 * client can read it synchronously on every request; React re-renders are driven by
 * the auth store instead. The rotating refresh token is an httpOnly cookie the
 * browser holds — JS never sees it.
 */
let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
